// extracted by mini-css-extract-plugin
export var actions = "_v2-4";
export var item = "_v2-1";
export var price = "_v2-3";
export var quantity = "_v2-2";
export var table = "_v2-0";